export enum VehicleOptionType {
  ACCESSORY_EXTERIOR = 'ACCESSORY_EXTERIOR',
  ACCESSORY_INFOTAIMENT = 'ACCESSORY_INFOTAIMENT',
  ACCESSORY_INTERIOR = 'ACCESSORY_INTERIOR',
  ACCESSORY_LEATHER = 'ACCESSORY_LEATHER',
  ACCESSORY_ORIGINAL = 'ACCESSORY_ORIGINAL',
  ACCESSORY_OTHER = 'ACCESSORY_OTHER',
  ACCESSORY_PARKING = 'ACCESSORY_PARKING',
  ACCESSORY_REAR_VIEW_MIRRORS = 'ACCESSORY_REAR_VIEW_MIRRORS',
  ACCESSORY_THIRD_PARTY = 'ACCESSORY_THIRD_PARTY',
  COLOR_EXTERIOR = 'COLOR_EXTERIOR',
  COLOR_INTERIOR = 'COLOR_INTERIOR',
  EQUIPMENT = 'EQUIPMENT',
  EQUIPMENT_AIRBAGS = 'EQUIPMENT_AIRBAGS',
  EQUIPMENT_AIR_CONDITIONING = 'EQUIPMENT_AIR_CONDITIONING',
  EQUIPMENT_CAR_ALARM = 'EQUIPMENT_CAR_ALARM',
  EQUIPMENT_DRIVER_ASSISTANCE = 'EQUIPMENT_DRIVER_ASSISTANCE',
  EQUIPMENT_MULTIFUNCTION_STEERING_WHEEL = 'EQUIPMENT_MULTIFUNCTION_STEERING_WHEEL',
  EQUIPMENT_SPEED_CONTROL = 'EQUIPMENT_SPEED_CONTROL',
  EQUIPMENT_HARBOUR = 'EQUIPMENT_HARBOUR',
  EXTENDED_WARRANTY = 'EXTENDED_WARRANTY',
  EXTENDED_WARRANTY_MANUFACTURER = 'EXTENDED_WARRANTY_MANUFACTURER',
  PACKAGE = 'PACKAGE',
  PACKAGE_BLUETOOTH = 'PACKAGE_BLUETOOTH',
  PACKAGE_CAMERA = 'PACKAGE_CAMERA',
  PACKAGE_KEYLESS = 'PACKAGE_KEYLESS',
  PACKAGE_NAVIGATOR = 'PACKAGE_NAVIGATOR',
  PACKAGE_SUN_ROOF = 'PACKAGE_SUN_ROOF',
  PACKAGE_WALLBOX = 'PACKAGE_WALLBOX',
  RIM = 'RIM',
  SYSTEM_EQUIPMENT = 'SYSTEM_EQUIPMENT',
  SYSTEM_EQUIPMENT_FULL_LED_HEADLIGHTS = 'SYSTEM_EQUIPMENT_FULL_LED_HEADLIGHTS',
  TIRE = 'TIRE',
  UPHOLSTERY = 'UPHOLSTERY',
  VEHICLE_COMPACT_SPARE_TYRE = 'VEHICLE_COMPACT_SPARE_TYRE',
  WHEELS_RIM_ALLOY = 'WHEELS_RIM_ALLOY',
}

export const betterBeOptionTypeToWebCalc: Readonly<Record<string, VehicleOptionType>> = {
  exterior_color: VehicleOptionType.COLOR_EXTERIOR,
  interior_color: VehicleOptionType.COLOR_INTERIOR,
  normal: VehicleOptionType.EQUIPMENT,
};

export enum PaymentFrequency {
  MONTHLY = 'MONTHLY',
  ONE_OFF = 'ONE_OFF',
}

export enum AdditionalProductType {
  CHARGE_AND_FUEL_CARD = 'CHARGE_AND_FUEL_CARD',
  CREDIT_PROTECTION_INSURANCE = 'CREDIT_PROTECTION_INSURANCE',
  DOUBLE_ENTRY_BOOKKEEPING = 'DOUBLE_ENTRY_BOOKKEEPING',
  EQUIPMENT = 'EQUIPMENT',
  IMPORTER_EXTENDED_WARRANTY = 'IMPORTER_EXTENDED_WARRANTY',
  INSURANCE_DRIVER = 'INSURANCE_DRIVER',
  INSURANCE_EVENT_COVERAGE = 'INSURANCE_EVENT_COVERAGE',
  INSURANCE_LRV = 'INSURANCE_LRV',
  INSURANCE_LRV_PLUS = 'INSURANCE_LRV_PLUS',
  INSURANCE_MOBILITY = 'INSURANCE_MOBILITY',
  INSURANCE_VEHICLE_TOTAL_DAMAGE = 'INSURANCE_VEHICLE_TOTAL_DAMAGE',
  INSURER_EXTENDED_WARRANTY = 'INSURER_EXTENDED_WARRANTY',
  LEASING_PROTECTION_INSURANCE = 'LEASING_PROTECTION_INSURANCE',
  LEASING_PROTECTION_INSURANCE_MOBILITY = 'LEASING_PROTECTION_INSURANCE_MOBILITY',
  LEASING_PROTECTION_INSURANCE_PLUS = 'LEASING_PROTECTION_INSURANCE_PLUS',
  LEASING_PROTECTION_INSURANCE_PLUS_MOBILITY = 'LEASING_PROTECTION_INSURANCE_PLUS_MOBILITY',
  LRV = 'LRV',
  LRV_PLUS = 'LRV_PLUS',
  MAINTENANCE = 'MAINTENANCE',
  MOBILITY = 'MOBILITY',
  MOTOR_INSURANCE = 'MOTOR_INSURANCE',
  MOTOR_INSURANCE_50_50 = 'MOTOR_INSURANCE_50_50',
  OTHER = 'OTHER',
  PRE_EXISTING_VEHICLE_INSURANCE = 'PRE_EXISTING_VEHICLE_INSURANCE',
  SERVICE_PACKAGE_L = 'SERVICE_PACKAGE_L',
  SERVICE_PACKAGE_M = 'SERVICE_PACKAGE_M',
  SERVICE_PACKAGE_S = 'SERVICE_PACKAGE_S',
  SERVICE_SUMMER_TIRES = 'SERVICE_SUMMER_TIRES',
  SERVICE_TIRE = 'SERVICE_TIRE',
  TAX_BALANCE_SHEET = 'TAX_BALANCE_SHEET',
  TIRE_SERVICE = 'TIRE_SERVICE',
  VEHICLE_IDENTIFICATION = 'VEHICLE_IDENTIFICATION',
  VEHICLE_EXTENDED_WARRANTY = 'VEHICLE_EXTENDED_WARRANTY',
  VEHICLE_TITLE = 'VEHICLE_TITLE',
}

export const MappingTableAdditionalProductType = {
  SERVICE_PLAN: 'SERVICE_PLAN',
  MAINTENANCE_REPAIR: 'MAINTENANCE_REPAIR',
  SERVICE_MAINTENANCE: 'SERVICE_MAINTENANCE',
  SERVICE_TIRE: 'SERVICE_TIRE',
  ROAD_TAX: 'ROAD_TAX',
  ROADSIDE_ASSISTANCE: 'ROADSIDE_ASSISTANCE',
  REPLACEMENT_VEHICLE: 'REPLACEMENT_VEHICLE',
  CHARGE_AND_FUEL_CARD: 'CHARGE_AND_FUEL_CARD',
  TOLL_TAG: 'TOLL_TAG',
  TELEMATICS: 'TELEMATICS',
} as const;
